<template>
  <v-app>
    <v-alert v-if="isPortrait" class="mb-0" dense tile type="info"
      >Portrait mode detected. ANT works best in landscape mode
      <v-icon class="ml-2">mdi-phone-rotate-landscape</v-icon>
    </v-alert>
    <v-main class="app" style="overflow-y: hidden">
      <transition mode="out-in" name="scale-fade-up">
        <router-view />
      </transition>
    </v-main>
    <notification />
  </v-app>
</template>

<script>
import LocalStorageService from '@/services/local-storage';
import viewportStyleMixin from '@/Mixins/ViewportStyleMixin';

export const APP_TITLE = 'ANT CDE';
export default {
  name: 'App',
  metaInfo() {
    return { title: `${APP_TITLE}` };
  },
  components: {
    Notification: () =>
      import(/* webpackPrefetch: true */ './components/Notification'),
  },
  mixins: [viewportStyleMixin],
  mounted() {
    if (
      LocalStorageService.getToken() !== null &&
      LocalStorageService.isTokenExpired()
    ) {
      LocalStorageService.removeToken();
      LocalStorageService.removeTokenExpiresIn();

      // Keep the page the user came in on, so the redirect after re-login
      // returns them there instead of dropping them on the dashboard.
      // Read the location rather than $route: at this point the initial
      // navigation may not have been confirmed yet, and $route would still be
      // the start route. This matches what the 401 interceptor records.
      if (!/login$/.test(window.location.pathname)) {
        this.$router.push({
          name: 'Login',
          query: {
            redirect: window.location.pathname + window.location.search,
          },
        });
      }
    }
  },
};
</script>

<style lang="scss">
@import 'css/main.scss';
@import 'css/transitions.scss';

.app {
  background-color: #e6e9f0;
}
</style>
